// Revival: review highlights from Klaviyo Reviews (v4.6; replaces the Yotpo version).
// Reads the same public endpoint Klaviyo's own product reviews widget uses
// (fast.a.klaviyo.com/reviews/api/client_reviews/<product id>/, public company id only, no private key).
// Shows the N most recent 5-star reviews with meaningful text. If the request fails or nothing qualifies,
// the block stays hidden. Stars and counts under the title come from Shopify's reviews.* metafields (Liquid).
(function () {
  var script = document.currentScript;
  var pid = script && script.dataset.productId;
  var company = script && script.dataset.klaviyoCompany;
  if (!company) {
    var src = Array.prototype.map.call(document.scripts, function (s) { return s.src || ''; })
      .filter(function (s) { return /klaviyo\.com\/onsite\/js\/.*company_id=/.test(s) || /klaviyo\.js\?company_id=/.test(s); })[0] || '';
    var m = src.match(/company_id=([A-Za-z0-9]+)/);
    company = m && m[1];
  }
  if (!pid || !company || window.__rvReviewsLoaded) return;
  window.__rvReviewsLoaded = true;

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  var url = 'https://fast.a.klaviyo.com/reviews/api/client_reviews/' + encodeURIComponent(pid) + '/' +
    '?product_id=' + encodeURIComponent(pid) + '&company_id=' + encodeURIComponent(company) +
    '&limit=30&offset=0&sort=1&type=reviews&media=false'; // sort=1: highest rating, newest first

  fetch(url)
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function (data) {
      var box = document.querySelector('[data-rv-review-highlights]');
      if (!box) return;
      var want = Number(box.dataset.count || 2);
      var picks = (data.reviews || []).filter(function (r) {
        return r.status === 'Published' && !r.is_store && Number(r.rating) === 5 && String(r.content || '').trim().length >= 25;
      }).sort(function (a, b) { return String(b.created_at).localeCompare(String(a.created_at)); }).slice(0, want);
      if (!picks.length) return;
      box.querySelector('[data-rv-rh-list]').innerHTML = picks.map(function (r) {
        var date = r.created_at ? new Date(r.created_at).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }) : '';
        var title = String(r.title || '').trim();
        var body = String(r.content || '').trim();
        if (body.length > 220) body = body.slice(0, 217).replace(/\s+\S*$/, '') + '…';
        var showTitle = title && body.toLowerCase().indexOf(title.toLowerCase()) !== 0;
        return '<li class="rv-rh__item">' +
          '<div class="rv-rh__head"><span class="rv-stars" style="--rv-rating:5" aria-label="5 out of 5 stars"></span>' +
          '<span>' + esc(r.author || 'Customer') + '</span>' +
          (r.verified ? '<span class="rv-rh__verified">Verified buyer</span>' : '') +
          (date ? '<span>' + esc(date) + '</span>' : '') + '</div>' +
          '<p class="rv-rh__text">' + (showTitle ? '<strong>' + esc(title) + '</strong>' : '') + esc(body) + '</p></li>';
      }).join('');
      box.hidden = false;
    })
    .catch(function () { /* reviews are optional */ });
})();
